import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  Space,
  Modal,
  message,
} from "antd";
import {
  DownloadOutlined,
} from "@ant-design/icons";
import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";
import { filter } from "lodash";

export const TransactionButtons = ({ filters, tabName }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const { permissions } = usePermissions();

  console.log("tabName : ", tabName)

  const downloadCSV = () => {
    const totalSize = filters.pagination?.totalSize ?? "";
    const messageContent = (
      <p>
        Are you sure you want to download {totalSize}{" "}
        transactions {tabName || filters.types} data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download Transaction List ? `,
      async onOk() {
        setIsDownloading(true);
        try {
          await axios.get("api/transactions/export", { params: filters });
          message.info(`Please check the Export progress in System -> Jobs`);
        } catch (error) {
          message.error(error.message);
        } finally {
          setIsDownloading(false);
        }
      },
    });
  };

  return (
    <div style={{ marginBottom: 16, float: "right" }}>
      <Space>
        {(
          permissions?.includes(PERMISSIONS.EXPORT_TRANSACTION_LIST) ||
          (filters.types === "weight-dispute" && permissions?.includes(PERMISSIONS.EXPORT_TRANSACTION_WEIGHT_DISPUTE))
        ) && (
            <span>
              <Button onClick={downloadCSV} loading={isDownloading}>
                CSV <DownloadOutlined />
              </Button>
            </span>
          )}
      </Space>
    </div>
  );
};

export default TransactionButtons;
